module.exports = __webpack_public_path__ + "img/P57-zh.62f14beb.png";